export default "__VITE_PUBLIC_ASSET__06d3f52c__"